export default "__VITE_ASSET__536ed25b__"